import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import HouseDimensionsAndInclusions from "@/components/builder/budget-houses/house-details/HouseDimensionsAndInclusions.vue";
  import BuilderSliderMobile from "@/components/builder/budget-houses/house-details/BuilderSliderMobile.vue";
  import { BuilderToggleDropdown } from "@/enums/BuilderToggleDropdown";
  import { FacadeInterface } from "@/types/FacadeInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'FloorplanAndInclusionsMobile',
  props: {
    houseInfo: {}
  },
  emits: ["update:selectedFacade"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;

  const onUpdateSelectedFacade = (facade: FacadeInterface) =>
    emits("update:selectedFacade", facade);

  const sectionStates = ref({
    floorplan: true,
    facade: true,
    dimensions: false,
    inclusions: false,
  });

  const fadeInEffect = ref({
    floorplan: true,
    facade: true,
    dimensions: false,
    inclusions: false,
  });

  const toggleSection = (section: keyof typeof sectionStates.value) => {
    sectionStates.value[section] = !sectionStates.value[section];

    setTimeout(() => {
      fadeInEffect.value[section] = !fadeInEffect.value[section];
    }, 50);
  };

const __returned__ = { props, emits, onUpdateSelectedFacade, sectionStates, fadeInEffect, toggleSection, ref, get HouseDesignInterface() { return HouseDesignInterface }, HouseDimensionsAndInclusions, BuilderSliderMobile, get BuilderToggleDropdown() { return BuilderToggleDropdown }, get FacadeInterface() { return FacadeInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})